import { IListarEquipesVendas } from "../../../Interfaces/Vendas/EquipeVendas/EquipeVendasInterfaces";
import {
    AtualizaEquipeVendasService,
    DeletaEquipeVendasService,
    ExportarEquipeVendasService,
    GetEquipesDeVendasService,
    InsereEquipeVendasService,
    ListarEquipeDeVendaPorUsuarioVendasService,
    ListarEquipeDeVendasService,
    ListarEquipesDeVendasSemLoginService,
    ListarEquipesDeVendasService,
} from "../../../Services/Vendas/EquipeVendas/EquipeVendasServices";
import { Controller } from "../../Controller";

export async function ListarEquipesDeVendasController() {
    return Controller(ListarEquipesDeVendasService());
}

export async function ListarEquipesDeVendasSemLoginController(
    idOrganizacao: number
) {
    return Controller(ListarEquipesDeVendasSemLoginService(idOrganizacao));
}

export async function GetEquipesDeVendasController(idEquipeVendas: number) {
    return Controller(GetEquipesDeVendasService(idEquipeVendas));
}

export async function InsereEquipeVendasController(
    requestBody: IListarEquipesVendas
) {
    return Controller(InsereEquipeVendasService(requestBody));
}
export async function AtualizaEquipeVendasController(
    requestBody: IListarEquipesVendas
) {
    return Controller(AtualizaEquipeVendasService(requestBody));
}
export async function DeletaEquipeVendasController(idEquipeVendas: number) {
    return Controller(DeletaEquipeVendasService(idEquipeVendas));
}

export async function ExportarEquipeVendasController() {
    return Controller(ExportarEquipeVendasService());
}

export async function ListarEquipeDeVendaPorUsuarioVendasController() {
    return Controller(ListarEquipeDeVendaPorUsuarioVendasService());
}

export async function ListarEquipeDeVendasController() {
    return Controller(ListarEquipeDeVendasService());
}
